import { create } from "zustand";

export interface ISuspendedModalState {
  isSuspendedModalOpen: boolean;
  setIsSuspendedModalOpen: (val: boolean) => void;
}

export const useSuspendedModalStore = create<ISuspendedModalState>((set) => ({
  isSuspendedModalOpen: false,
  setIsSuspendedModalOpen: (isOpen: boolean) =>
    set({ isSuspendedModalOpen: isOpen }),
}));
